import { jsx as _jsx } from "react/jsx-runtime";
import TutorPage from "./TutorPage";
export default function FunctionsPage() {
    return _jsx(TutorPage, { initialTopic: "Functions", lockTopic: true });
}
